export const ROUTES = {
  LOGIN: '/',
}
